import { Button, Collapse, Grid } from "@mui/material";
import { useState } from "react";
import { Box } from "@mui/system";
import { useNavigate } from "react-router-dom";

import PageRoutes from "../Config/PageRoutes";
import neg1 from "../Assets/neg1.png";

//components
import Findings from "../Components/ChapterOne/Findings";
import GroupBulletChart from "../Components/Charts/GroupBulletChart";
import ModalTrigger from "../Components/Common/ModalTrigger";
import CircleSvg from "./../Components/CircleSvg";
import DottedCircleSvg from "./../Components/DottedCircleSvg";

//charts
import HorizontalBarChart from "../Components/Charts/HorizontalBarChart";
import HeatMapChart from "../Components/Charts/HeatMapChart";
import TableGrid from "../Components/ChapterOne/TableGrid";

// csv
import csv1 from "../Data/EUMACP/Overview/EU-MACP-Overview-Sample-origin-per-country-of-sampling-Stacked-bar-chart.csv";
import csv3 from "../Data/EUMACP/Overview/EU-MACP-Overview-No-of-quantified-residues-per-sample-XY-heatmap.csv";
import csv4 from "../Data/EUMACP/Overview/EU-MACP-Overview-Reporting-country-response-to-EU-MACP-regulations-Bullet-chart.csv";
import csv5 from "../Data/EUMACP/Overview/EU-MACP-Overview-Summary-of-findings-Country-of-origin.csv";
import csvToDownload from "../Data/EUMACP/Overview/Pesticides_coverage.csv";

//maps
import FirstRow from "../Components/ChapterOne/rows/FirstRow";
import FourthRow from "../Components/ChapterOne/rows/FourthRow";

const ChapterOne = () => {
  const navigate = useNavigate();

  const [expanded, setExpanded] = useState(false);
  const handleExpandClick = () => {
    setExpanded(!expanded);
  };
  const goToChapterTwo = () => {
    navigate("../" + PageRoutes.CHAPTER_TWO);
  };

  return (
    <Grid container direction="column" className="wrapper-one">
      <Grid container direction="column" className="chapterOneWrapper">
        {/* First row */}
        <FirstRow />
        {/* First row */}

        {/* Second row */ }
        <Grid
          item
          container
          direction={ {xs: "column", sm: "column", md: "row"} }
          sx={ {
            marginTop: {xs: "50px", sm: "50px", md: "30px"},
            alignItems: {sm: "center", md: "center"},
            width: "100%",
          } }
          className="two-one-wrapper"
        >
          <div className="circle-svg">
            <CircleSvg/>
          </div>
          <Grid
            item
            xs
            p={ 3 }
            className="two-one"
            sx={ {maxWidth: {md: "450px !important"}} }
          >
            <Box sx={ {textAlign: {sm: "center", md: "left"}} }>
              <h3>Results by sampling region</h3>
              <p className="paragraph">
                A total of 9,842 samples were taken for the{ " " }
                <ModalTrigger
                  style={ {
                    color: "#22294D",
                    cursor: "pointer",
                    borderBottom: "1px dotted",
                  } }
                  text="EU MACP"
                />
                . Of these, on average 46.6% of the samples analysed were{ " " }
                <ModalTrigger
                  style={ {
                    color: "#22294D",
                    cursor: "pointer",
                    borderBottom: "1px dotted",
                  } }
                  text="domestic"
                />
                , 29.3% were from other reporting countries, 20.1% were from{ " " }
                <ModalTrigger
                  style={ {
                    color: "#22294D",
                    cursor: "pointer",
                    borderBottom: "1px dotted",
                  } }
                  text="third countries"
                />
                , and 4.0% were of unknown origin.
              </p>

              <p>
                Countries with more than 80% of domestic samples were Lithuania (100%), Spain (88.8%) and Italy (81.5%). Most of the third-country samples were reported by the Netherlands (40.2%), followed by Denmark (36.9%) and Ireland (33.1%).
              </p>
              <p>
                More than 10% of samples in the Netherlands (13.8%) and Germany (12.1%) were of unknown origin.
              </p>
            </Box>
          </Grid>
          <Grid item xs p={ 3 } className="two-two" width="100%">
            <HorizontalBarChart
              csv={ csv1 }
              title="Sample origin percentage per country of sampling"
              yField="Reporting country"
              xField="Region proportion per country"
              stackField="Pesticide region"
            />
          </Grid>
        </Grid>
        {/* Second row */ }
        {/* Third row */ }
        <Grid
          item
          container
          direction="column"
          sx={ {
            marginTop: {xs: "50px", sm: "50px", md: "90px"},
            backgroundColor: "#F8F8F8",
          } }
          alignContent="center"
        >
          <Grid item xs p={ 3 } className="three-one">
            <Box
              sx={ {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              } }
              className="three-one-inner"
            >
              <h3>Overall EU MACP findings</h3>
              <p>
                In 43.1% (4,241 of 9,842) of samples analysed, no{ " " }
                <ModalTrigger
                  style={ {
                    color: "#22294D",
                    cursor: "pointer",
                    borderBottom: "1px dotted",
                  } }
                  text="quantifiable levels"
                />{ " " }
                of residues were reported (residues were below the Limit of Quantification, or{ " " }
                <ModalTrigger
                  style={ {
                    color: "#22294D",
                    cursor: "pointer",
                    borderBottom: "1px dotted",
                  } }
                  text="LOQ"
                />
                ). The percentage of samples with pesticide residues within legally permitted levels (at or{ " " }
                <ModalTrigger
                  style={ {
                    color: "#22294D",
                    cursor: "pointer",
                    borderBottom: "1px dotted",
                  } }
                  text="above the LOQ but below or at the Maximum residue level, or MRL"
                />
                ) was 54.5% (5,367). <ModalTrigger
                style={ {
                  color: "#22294D",
                  cursor: "pointer",
                  borderBottom: "1px dotted",
                } }
                text="MRLs"
              /> were exceeded in 2.4% (234) of samples, of which 1.2% (113) were found to be{ " " }
                <ModalTrigger
                  style={ {
                    color: "#22294D",
                    cursor: "pointer",
                    borderBottom: "1px dotted",
                  } }
                  text="non-compliant"
                />{ " " }
                due to measurement uncertainty.
              </p>
            </Box>
          </Grid>
          <Grid item xs p={ 3 } className="three-two">
            <Findings chartImg={ neg1 }/>
          </Grid>
        </Grid>
        {/* Third row */ }

        {/* Fourth row */ }
        <FourthRow/>
        {/* Fourth row */ }

        {/* Fifth row */ }
        <Grid
          item
          container
          direction={ {xs: "column", sm: "column", md: "row"} }
          sx={ {marginTop: {xs: "50px", sm: "50px", md: "90px"}} }
          className="five-one-wrapper"
          justifyContent="center"
          alignItems="center"
        >
          <div className="circle-svg-fifth-row">
            <CircleSvg/>
          </div>
          <Grid
            item
            xs
            p={ 3 }
            className="five-one"
            // p='40px'
            display="flex"
            justifyContent="center"
            alignItems="center"
            sx={ {
              maxWidth: {md: "450px !important"},
            } }
          >
            <Box
              sx={ {
                textAlign: {xs: "left", sm: "center", md: "left"},
                padding: {xs: "0", sm: "24px", md: "0"},
              } }
            >
              <h3>Quantified residues per sample</h3>
              <p className="paragraph">
                Of the 9,842 samples, 56.9% (5,601) had quantified results and 34.9% (3,432) contained more than one quantified pesticide. Table grapes (77.9%), grapefruits (73.5%) and bananas (66.1%) had the highest{ " " }
                <ModalTrigger
                  style={ {
                    color: "#fff",
                    cursor: "pointer",
                    borderBottom: "1px dotted",
                  } }
                  text="percentages of multiple residues"
                />
                .
              </p>
              <p className="paragraph">
                The highest number of pesticide residues was found in one sample of sweet/bell pepper grown in a third country. The sample contained 17 different pesticides, all{ " " }
                <ModalTrigger
                  style={ {
                    color: "#fff",
                    cursor: "pointer",
                    borderBottom: "1px dotted",
                  } }
                  text="quantified"
                />
                { " " } below the MRL values.
              </p>
            </Box>
          </Grid>
          <Grid item xs p={ 3 } className="five-two" width="100%">
            <HeatMapChart
              title="Number of quantified residues per sample"
              csv={ csv3 }
              yAxisName="Food commodity"
              xAxisName="Number of quantifications"
              valueField="Proportion per food commodity"
            />
          </Grid>
        </Grid>
        {/* Fifth row */ }
        {/* Sixth row */ }
        <Grid
          item
          container
          direction={ {xs: "column", sm: "column", md: "row"} }
          sx={ {marginTop: {xs: "50px", sm: "50px", md: "90px"}} }
        >
          <Box
            p={ 3 }
            className="three-one-inner"
            sx={ {
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            } }
          >
            <Grid item xs={ 12 } className="six-one">
              <h3>Pesticide analysis coverage</h3>
            </Grid>
            <p className="paragraph">
              Member States must report data on each of the 200 pesticides listed in the EU MACP. The target is calculated considering the minimum number of samples (683 per commodity) to be reported by each country and compared against the total number of reported results. The pesticides shown below are a subset of the 86 pesticides for which the minimum number was not reached.
            </p>
          </Box>
          <Grid
            item
            container
            display={ {xs: "none", sm: "none", md: "flex"} }
            alignItems="center"
            justifyContent="center"
          >
            <Grid item container display="flex" direction={ {md: "row"} }>
              <Grid
                item
                xs
                p={ 3 }
                pt={ 0 }
                sx={ {width: "50%"} }
                className="six-three"
                display={ {xs: "none", sm: "none", md: "block"} }
              >
                <Collapse
                  style={ {width: "100%"} }
                  collapsedSize={ 700 }
                  in={ expanded }
                  timeout="auto"
                >
                  <GroupBulletChart
                    csvToDownlaod={ csvToDownload }
                    first
                    title="Number of results per pesticide against EU MACP target"
                    part={ 1 }
                    csv={ csv4 }
                  />
                </Collapse>
              </Grid>
              <Grid
                item
                xs
                p={ 3 }
                pt={ 0 }
                sx={ {width: "50%"} }
                className="six-four"
                display={ {xs: "none", sm: "none", md: "block"} }
              >
                <GroupBulletChart
                  csvToDownlaod={ csvToDownload }
                  second
                  title="Number of results per pesticide against EU MACP target"
                  part={ 2 }
                  csv={ csv4 }
                />
              </Grid>
            </Grid>
          </Grid>
          {/* mobile view */ }
          <Grid
            item
            xs={ 12 }
            p={ 3 }
            display={ {xs: "flex", sm: "flex", md: "none"} }
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
          >
            <Collapse
              style={ {width: "100%"} }
              collapsedSize={ 350 }
              in={ expanded }
              timeout="auto"
            >
              <GroupBulletChart
                csvToDownlaod={ csvToDownload }
                title="Number of results per pesticide against EU MACP target"
                csv={ csv4 }
              />
            </Collapse>
            <Button
              style={ {
                marginTop: "1rem",
                color: "#22294D",
                borderColor: "#22294D",
              } }
              className="footerButton"
              variant="outlined"
              onClick={ handleExpandClick }
            >
              { expanded ? "Show less" : "Load more" }
            </Button>
          </Grid>
        </Grid>
        {/* Sixth row */ }
        {/* Seventh row */ }
        <Grid
          item
          container
          direction="row"
          sx={ {marginTop: {xs: "50px", sm: "50px", md: "90px"}} }
          className="tableGrid"
        >
          <Grid item xs p={ 3 } className="seven-one">
            <TableGrid csv={ csv5 }/>
          </Grid>
        </Grid>
        {/* Seventh row */ }

        {/* Eighth row , footer*/ }

        <Grid
          item
          container
          direction="column"
          // sx={{ marginTop: { xs: '50px', sm: '50px', md: '250px' } }}
          alignContent="center"
          className="footerWrapper"
        >
          <div className="dottedCircle">
            <DottedCircleSvg/>
          </div>
          <Grid item xs className="footer">
            <Box className="nine-one-inner">
              <p style={ {textAlign: "center"} }>
                <b>Continue exploring</b>
              </p>
              <Button
                onClick={ goToChapterTwo }
                className="footerButton"
                variant="outlined"
              >
                Results of National Programmes
              </Button>
            </Box>
          </Grid>
        </Grid>
        {/* Eighth row */ }
      </Grid>
    </Grid>
  );
};

export default ChapterOne;

